import { api } from 'api'
import { ErrorsNoData } from 'constants/actionMessages'
import { getCreatorAsyncSlice } from 'modules/store'

import { RootState } from '..'

const { createAsyncSlice } = getCreatorAsyncSlice<RootState>({ nameReducer: 'promoOptimizerSettings' })

export const { getHosts, selectHosts, initialSliceHosts, sliceCasesHosts } = createAsyncSlice({
  nameAction: 'getHosts',
  nameSlice: 'hosts',
  promise: api.promoOptimizerSettings.getHosts,
  error: ErrorsNoData.Hosts,
})

export const { getEndpoints, selectEndpoints, initialSliceEndpoints, sliceCasesEndpoints } = createAsyncSlice({
  nameAction: 'getEndpoints',
  nameSlice: 'endpoints',
  promise: api.promoOptimizerSettings.getEndpoints,
  error: ErrorsNoData.Endpoints,
})
